import React, { Component } from 'react';
import { ActivityIndicator, TextInput } from 'react-native';
import { withSnackbar } from 'notistack';

import { loadStripe } from '@stripe/stripe-js';
import { CardCvcElement, CardExpiryElement, CardNumberElement, injectStripe } from 'react-stripe-elements';

import LoadingModal from '../../../../components/atoms/LoadingModal';
import MessageModal from '../../../../components/molecules/MessageModal';
import { getPaymentInfo_API, verifyPromocode_API } from '../../../../shared/services/api/apiCard';
import './style.scss';
import { ScreenTitle } from '../../../../components';
import { ROUTE_CONSTANTS } from '../../../../shared/constants/Route';

import { checkOffline } from '../../../../shared/services/Utility';
import {
  OFFLINE_USER,
  SESSION_EXPIRED,
  SESSION_EXPIRED_CODE,
  SOMETHING_WRONG,
  Strings,
} from '../../../../shared/constants/Constants';

const stripePromise = loadStripe('pk_live_TIczmo1kNehMkouK0OnqzWIE');

class PurchaseScreen extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showModal: false,
      message: '',
      couponButton: true,
      payButtonDisabled: true,
      stripe_key: '',
      payAmount: 0,
      netAmountPay: 0,
      couponCodeText: '',
      appliedCode: '',
      toggleLoader: false,
      toggleCouponL: false,
      name: '',
      nameCard: 'XXXX XXXX XXXX XXXX',
      cardNumber: '',
      cvcCode: '',
      month: '',
      year: '',
      paySuccessful: false,
      nameError: '',
    };
  }

  // const[showModal, updateModal] = useState(false);
  // const[message, updateMessage] = useState('');

  // const[couponButton, updateCouponButton] = useState(true);
  // const[payButtonDisabled, updatePayButtonDisabled] = useState(true);

  // const[stripe_key, updateStripe_Key] = useState('');

  // const[payAmount, updatePayAmount] = useState(0);
  // const[netAmountPay, updateNetAmount] = useState(0);

  // const[couponCodeText, updateCoupon_Code] = useState('');
  // const[appliedCode, updateAppliedCode] = useState('');

  // const[toggleLoader, updateLoader] = useState(false);
  // const[toggleCouponL, updateCouponLoader] = useState(false);

  // const[name, updateName] = useState('');
  // const[nameCard, updateNameCard] = useState('XXXX XXXX XXXX XXXX');
  // const[cardNumber, updateCardNum] = useState('');
  // const[cvcCode, updateCvcCode] = useState('');
  // const[month, updateMonth] = useState('');
  // const[year, updateYear] = useState('');

  componentDidMount() {
    this.getPaymentInfo();
  }

  async getPaymentInfo() {
    if (checkOffline()) {
      this.props.enqueueSnackbar(OFFLINE_USER, {
        variant: 'error',
        autoHideDuration: 3000,
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'left',
        },
      });
    } else {
      const requestPayAmount = {
        sessionToken: this.props.sessionToken,
        userId: this.props.userId,
      };

      this.setState({
        toggleLoader: true,
      });

      //updateLoader(true);

      await getPaymentInfo_API(requestPayAmount).then((result) => {

        this.setState({
          toggleLoader: false,
        });

        // updateLoader(false);

        if (result.status === 1 || result.status === 200) {
          this.setState({
            payAmount: result.amount,
            netAmountPay: result.amount,
            stripe_key: result.stripe_public_key,
            payButtonDisabled: false,
          });

          // updatePayAmount(result.amount);
          // updateNetAmount(result.amount);
          // updateStripe_Key(result.stripe_public_key);

          // updatePayButtonDisabled(false);
        } else if (result.status === SESSION_EXPIRED_CODE) {
          this.props.enqueueSnackbar(SESSION_EXPIRED, {
            variant: 'error',
            autoHideDuration: 3000,
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'left',
            },
          });
          this.props.Logout();
        }
      }).catch((error) => {
        if (checkOffline()) {
          this.props.enqueueSnackbar(OFFLINE_USER, {
            variant: 'error',
            autoHideDuration: 3000,
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'left',
            },
          });
        } else {
          this.props.enqueueSnackbar(SOMETHING_WRONG, {
            variant: 'error',
            autoHideDuration: 3000,
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'left',
            },
          });
        }
        // setTimeout(() => {
        //   Alert.alert(APP_NAME, PAYMENT_FAIL);
        // }, 600);

        this.setState({
          toggleLoader: false,
        });
        // updateLoader(false);
      });
    }
  }

  onClickPurchaseButton = () => {
    let paymentBody = {
      sessionToken: this.props.sessionToken,
      userId: this.props.userId,
      amount: this.state.payAmount,
      source: '',
      description: `testing by ${this.props.userId}`,
      appliedCoupon: this.state.appliedCode,
    };
    alert('number ' + this.state.cardNumber);

    if (this.state.payAmount.toString() === '0') {
      this.props.payment_authentication(paymentBody);
      return;
    }
    // const client = new Stripe(stripe_key);
    if (this.state.name === '') {
      //Alert.alert(APP_NAME, TextConstant.CARD_NANE_REQUIRED);
      return;
    } else if (this.state.cardNumber === '') {
      // Alert.alert(APP_NAME, TextConstant.CARD_NUMBER_REQUIRED);
      return;
    } else if (this.state.cvcCode === '') {
      //Alert.alert(APP_NAME, TextConstant.CARD_CVC_REQUIRED);
      return;
    } else if (this.state.month === null) {
      //Alert.alert(APP_NAME, TextConstant.CARD_EXPIRY_MONTH_REQUIRED);
      return;
    } else if (this.state.year === null) {
      // Alert.alert(APP_NAME, TextConstant.CARD_EXPIRY_YEAR_REQUIRED);
      return;
    } else {
      if (this.state.cardNumber.length < 15) {
        //Alert.alert(APP_NAME, TextConstant.CARD_NUMBER_SHORT_LENGTH);
        return;
      }
      if (this.state.cvcCode.length < 3) {
        // Alert.alert(APP_NAME, TextConstant.CARD_CVC_SHORT_LENGTH);
        return;
      }
      if (checkOffline()) {
        this.props.enqueueSnackbar(OFFLINE_USER, {
          variant: 'error',
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left',
          },
        });
        return;
      }
      // if (!isNetConnected) {
      //  // Alert.alert(APP_NAME, INTERNET_CHECK);
      //   return;
      // }
    }
    // Create a Stripe token with new card infos
    // client
    //   .createToken({
    //     number: cardNumber,
    //     exp_month: month,
    //     exp_year: year,
    //     cvc: cvcCode
    //     // address_zip: "12345"
    //   })
    //   .then(token => {
    //     if (token.error) {
    //       updateModal(true);
    //       updateMessage(token.error.message);
    //       // Alert.alert(APP_NAME, token.error.message);
    //     } else {
    //       paymentBody["source"] = token.id || "";
    //       payment_authentication(paymentBody);
    //     }
    //   });
  };

  async prormo_Code_Verify() {

    if (this.state.couponCodeText == '') {
      alert('Please enter your coupon!');
      return;
    } else if (checkOffline()) {
      this.props.enqueueSnackbar(OFFLINE_USER, {
        variant: 'error',
        autoHideDuration: 3000,
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'left',
        },
      });
    } else {
      const promoCodeBody = {
        sessionToken: this.props.sessionToken,
        userId: this.props.userId,
        couponCode: this.state.couponCodeText,
      };
      this.setState({
        toggleCouponL: true,
      });

      // updateCouponLoader(true)

      if (this.state.stripe_key.length === 0) {
        await this.getPaymentInfo();
        if (this.state.stripe_key.length === 0) {
          return;
        }
      }

      verifyPromocode_API(promoCodeBody).then((result) => {

        if (result.status === 200) {
          this.setState({
            couponButton: true,
            payAmount: result.netAmount,
            appliedCode: this.state.couponCodeText,
          });
          this.setState({
            message: 'Coupon code successfully applied.',
            showModal: true,
          });

          // updateCouponButton(true);
          // updatePayAmount(result.netAmount);

          // this.setState({
          //   disable_button: true,
          //   payAmount: result.netAmount,
          //   // disable_textCoupon: false,
          //   disable_card_button: result.netAmount === 0 ? false : true,
          //   appliedCode: this.state.couponCode
          // });

          // this.discount_payment(result.netAmount)
        } else {
          this.setState({
            message: 'Entered coupon is not valid!',
            showModal: true,
          });

          // updateModal(true);
          // updateMessage("Entered coupon is not valid!")
        }
        this.setState({
          toggleCouponL: false,
        });
        // updateCouponLoader(false)
      }).catch((error) => {
        if (checkOffline()) {
          this.props.enqueueSnackbar(OFFLINE_USER, {
            variant: 'error',
            autoHideDuration: 3000,
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'left',
            },
          });
        } else {
          this.props.enqueueSnackbar(SOMETHING_WRONG, {
            variant: 'error',
            autoHideDuration: 3000,
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'left',
            },
          });
        }
        this.setState({
          toggleCouponL: false,
        });
        // updateCouponLoader(false)
      });
    }
  }

  onchangeCoupon = (coupon_Code) => {
    this.setState({
      couponCodeText: coupon_Code,
      couponButton:
        coupon_Code.length >= 5 && coupon_Code !== this.state.appliedCode
          ? false
          : coupon_Code === this.state.appliedCode
            ? true
            : false,
    });
    // updateCoupon_Code(coupon_Code);
    // updateCouponButton(coupon_Code.length >= 5 && coupon_Code !== appliedCode ? false : coupon_Code === appliedCode ? true : false)
    // this.setState({
    //   disable_card_button:
    //     this.state.payAmount === 0 && coupon_Code === this.state.appliedCode
    //       ? false
    //       : true
    // });
  };

  onChangeCardName = (text) => {
    let str = text.toUpperCase();
    const nameRegex = /^[a-z .']+$/i;
    if (nameRegex.test(text) || text === '') {
      this.setState({
        name: str,
        nameError: '',
      });
    }
    //updateName(str);
  };

  onChangeCardNumber = (text) => {

    if (text.length <= 16) {
      let textArray = text.split('');
      let count = 0;
      let number_ = '';
      let c_ = '';
      for (let i = 1; i <= 16; i++) {
        if (i <= textArray.length) {
          c_ = textArray[i - 1];
        } else {
          c_ = 'X';
        }
        if (count % 4 === 0) {
          number_ += ' ' + c_;
        } else {
          number_ += c_;
        }
        count++;
      }
      this.setState({
        nameCard: number_,
        cardNumber: text,
      });
      // updateNameCard(number_);
      // updateCardNum(text);
    }
  };

  getMonthData = () => {
    let jsonArr = [];
    let count = 1;

    for (let i = 0; i < 12; i++) {
      jsonArr.push({
        value: count < 10 ? '0' + count : count,
        label: count < 10 ? '0' + count : count,
      });
      count++;
    }
    return jsonArr;
  };

  getYearData = () => {
    let jsonArr = [];
    let count = 18;

    for (let i = 0; i < 20; i++) {
      jsonArr.push({
        value: count,
        label: '20' + count,
      });
      count++;
    }
    return jsonArr;
  };
  handlesubmit = (e) => {
    e.preventDefault();

    if (this.state.name === '') {
      this.setState({
        nameError: Strings.nameEmpty,
      });
    } else {
      let paymentBody = {
        sessionToken: this.props.sessionToken,
        userId: this.props.userId,
        amount: this.state.payAmount,
        source: '',
        description: `testing by ${this.props.userId}`,
        //  appliedCoupon: this.state.appliedCode,
      };

      if (this.props && this.props.stripe) {
        this.props.stripe.createToken().then((token) => {

          if (token.error) {
            this.props.enqueueSnackbar(token.error.message, {
              variant: 'error',
              autoHideDuration: 3000,
              anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'left',
              },
            });
          } else {
            paymentBody['source'] = token.token.id || '';

            this.props.payment_authentication(
              paymentBody,
              (value, msg) => {
                if (value) {
                  this.setState({
                    message: msg,
                    showModal: true,
                    paySuccessful: true,
                  });
                } else {
                  this.setState({
                    message: msg,
                    showModal: true,
                  });
                }
              },
              (message, type) => {
                if (type !== 'success') {
                  this.props.enqueueSnackbar(message, {
                    variant: type,
                    autoHideDuration: 3000,
                    anchorOrigin: {
                      vertical: 'bottom',
                      horizontal: 'left',
                    },
                  });
                }
              },
            );
          }
        }).catch((err) => {

        });
      }
    }

    if (this.state.payAmount.toString() === '0') {
      let paymentBody = {
        sessionToken: this.props.sessionToken,
        userId: this.props.userId,
        amount: this.state.payAmount,
        source: '',
        description: `testing by ${this.props.userId}`,
        appliedCoupon: this.state.appliedCode,
      };

      this.props.payment_authentication(
        paymentBody,
        (value, msg) => {
          if (value) {
            this.setState({
              message: msg,
              showModal: true,
              paySuccessful: true,
            });
          } else {
            this.setState({
              message: msg,
              showModal: true,
            });
          }
        },
        (message, type) => {
          if (type !== 'success') {
            this.props.enqueueSnackbar(message, {
              variant: type,
              autoHideDuration: 3000,
              anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'left',
              },
            });
          }
        },
      );

      return;
    }
  };

  // cardNumberElement.on('change', function(event) {
  //   if (event.error) {
  //     // show validation to customer
  //   }
  // });

  render() {
    const { name, nameError } = this.state;
    const errorStyle = { color: 'red', fontSize: 12, marginTop: '5px' };
    return (
      <>
        {this.state.showModal && (
          <MessageModal
            title={'Prep2pass'}
            message={this.state.message}
            callback={() => {
              if (this.state.paySuccessful) {
                this.props.history.replace(ROUTE_CONSTANTS.DASHBOARD);
                this.setState({
                  message: '',
                  showModal: false,
                });
                return;
              }

              this.setState({
                message: '',
                showModal: false,
              });

              // updateMessage("");
              // updateModal(false);
            }}
          />
        )}
        <ScreenTitle title='Dashboard' subTitle='Purchase P2P'/>

        {this.props.loading ? (
          <LoadingModal isVisible={this.props.loading}/>
        ) : (
          <div className='form-div'>
            <form className=' purchase-form' onSubmit={this.handlesubmit}>
              {/* <CardNumberElement/> */}
              <div className='card_details'>
                {/* <div className="card-number">
                <p>{this.state.nameCard}</p>
              </div>
              <div className="name-date-container">
                <div className="full-name">{this.state.name ? this.state.name : "Full name"}</div>
                <div className="valid-date">
                  <p>Month/year</p>
                  <p>
                    valid thru <span>{this.state.month ? this.state.month : "__"}</span>/<span>{this.state.year ? this.state.year : "__"}</span>
                  </p>
                </div>
              </div> */}
                {/* <img
            style={{ alignItems: "center" }}
            src={require("../../../../Assets/Images/Icons/card.png")}
            alt=""
          /> */}
              </div>

              <div className='purchase-group'>
                <div className='row'>
                  <div className='col12 form-group'>
                    <label>Name on the card</label>
                    <TextInput
                      value={name}
                      className={'input'}
                      placeholder={'Full Name'}
                      onChangeText={(text) => {
                        this.onChangeCardName(text);
                      }}
                    />
                    {nameError && <p style={errorStyle}>{nameError}</p>}
                  </div>
                </div>
                <div className='row'>
                  <div className='col12 form-group'>
                    <label>Card Number</label>
                    {/* <TextInput
                    value={this.state.cardNumber}
                    className="form-control"
                    placeholder={"XXXX XXXX XXXX XXXX"}
                    onChangeText={(text) => { this.onChangeCardNumber(text) }}
                  //onChangeText={handleChange("cardNumber", "cardNumberError")}
                  /> */}
                    <CardNumberElement
                      placeholder={'XXXX XXXX XXXX XXXX'}
                      className={'input'}
                    />
                    {/* <input
                  type=""
                  className="form-control"
                  placeholder="XXXX XXXX XXXX XXXX"
                /> */}
                  </div>
                  {/*<div className="col4 form-group">

                   <TextInput
                    className="form-control"
                    placeholder="XXX"
                    value={this.state.cvcCode}
                    onChangeText={(text) => {
                      this.setState({ cvcCode: text })
                    }}
                  // updateCvcCode(text) }}
                  /> */}
                  {/* <input
                  type="text"
                  className="form-control"
                  placeholder="1234"
                />
                </div>*/}
                </div>
                <div className='row expiry_date'>
                  <div className='col12 form-group'>
                    <div className='row'>
                      <div className='col3 mr-2'>
                        <label>Expiry Date</label>
                        <CardExpiryElement className={'input'}/>
                        {/* <DropDown
                        data={this.getMonthData()}
                        callback={(selectedMonth) => {
                          this.setState({ month: selectedMonth })
                        }}
                      /> */}
                      </div>
                      <div className='col3 ml-1'>
                        <label>CVC Code</label>
                        <CardCvcElement className={'input'}/>
                        {/* <DropDown
                        data={this.getYearData()}
                        callback={(selectedYear) => {
                          this.setState({ year: selectedYear })
                        }}
                      /> */}
                      </div>
                    </div>
                  </div>
                </div>
                {/* <CardElement /> */}

                <div className='row apply_cupn'>
                  <div className='col9 form-group'>
                    <TextInput
                      className='input'
                      placeholder='Coupon Code'
                      value={this.state.couponCodeText}
                      onChangeText={(text) => {
                        this.onchangeCoupon(text);
                      }}
                    />
                    {/* <input
                  type=""
                  className="form-control"
                  placeholder="AGVDSCEFG145"
                /> */}
                  </div>

                  <div className='col3 btn_coupn'>
                    {this.state.toggleCouponL ? (
                      <ActivityIndicator
                        style={{
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}
                        color={'#7ebf41'}
                        size={'large'}
                      />
                    ) : (
                      <button
                        onClick={() => {
                          this.prormo_Code_Verify();
                        }}
                        disabled={this.state.couponButton}
                        className={
                          this.state.couponButton ? 'btn-grey' : 'btn-green'
                        }
                        type='button'
                      >
                        {this.state.netAmountPay == this.state.payAmount ||
                        this.state.couponCodeText !== this.state.appliedCode
                          ? 'Apply Code'
                          : 'Code Applied'}
                      </button>
                    )}
                  </div>
                  <div className='btn_wrap w-100'>
                    <button
                      // onClick={() => {
                      //   this.onClickPurchaseButton();
                      // }}
                      disabled={this.state.payButtonDisabled}
                      className='blue-btn mt-2 w-100'
                      // type="button"
                    >
                      {this.state.toggleLoader ? (
                        <ActivityIndicator color={'white'} size={'small'}/>
                      ) : (
                        `${'Pay'} \$${this.state.payAmount}`
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        )}
      </>
    );
  }
}

export default injectStripe(withSnackbar(PurchaseScreen));
